/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BookingUserEnvironment } from './BookingUserEnvironment';
import {
    BookingUserEnvironmentFromJSON,
    BookingUserEnvironmentFromJSONTyped,
    BookingUserEnvironmentToJSON,
    BookingUserEnvironmentToJSONTyped,
} from './BookingUserEnvironment';
import type { RateUpdateType } from './RateUpdateType';
import {
    RateUpdateTypeFromJSON,
    RateUpdateTypeFromJSONTyped,
    RateUpdateTypeToJSON,
    RateUpdateTypeToJSONTyped,
} from './RateUpdateType';

/**
 * 
 * @export
 * @interface VehicleBookingRequest
 */
export interface VehicleBookingRequest {
    /**
     * Search ID from the vehicle search
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    searchId: string;
    /**
     * Rate code of the selected vehicle
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    rateCode: string;
    /**
     * Rate option type selected by the renter. When provided, must match the selected rate code; never fall back to a different rate type.
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    selectedRateType?: string;
    /**
     * Vendor code
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    vendorCode: string;
    /**
     * ACRISS vehicle code
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    acrissCode: string;
    /**
     * Pickup airport IATA code of the selected vehicle, used to disambiguate
     * cached search items when a metro fanout produced multiple cards with
     * the same (vendor_code, acriss_code, rate_code) at different airports
     * (e.g., Avis Compact at JFK and LGA). Optional for backwards
     * compatibility; when omitted, the booker falls back to the first
     * (vendor_code, rate_code) match and may pick the wrong airport's
     * rate tokens.
     * 
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    pickupLocation?: string;
    /**
     * Vendor-specific pickup desk identifier for the selected card, used to
     * disambiguate city desks from airport desks that share vendor, rate,
     * ACRISS, and airport code. Optional for backwards compatibility.
     * 
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    vendorLocationId?: string;
    /**
     * Selected card desk classification (airport or city), used as a
     * fallback cached-item disambiguator when no vendor_location_id is
     * present. Optional for backwards compatibility.
     * 
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    deskKind?: string;
    /**
     * Selected extras/add-ons
     * @type {Array<string>}
     * @memberof VehicleBookingRequest
     */
    extras?: Array<string>;
    /**
     * Given name of the renter
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    givenName: string;
    /**
     * Family name of the renter
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    familyName: string;
    /**
     * Email address
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    emailAddress: string;
    /**
     * Phone number with country code
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    phoneNumber: string;
    /**
     * Payment method ID from trips service
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    paymentId: string;
    /**
     * Promotional code to apply to the booking. Must match the code used during search.
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    promotionalCode?: string;
    /**
     * Loyalty account ID to associate with the booking. The loyalty membership number will be sent to the vendor.
     * @type {string}
     * @memberof VehicleBookingRequest
     */
    loyaltyAccountId?: string;
    /**
     * When true, use test/pre-prod Travelport credentials and bypass VGS proxy
     * @type {boolean}
     * @memberof VehicleBookingRequest
     */
    test?: boolean;
    /**
     * When true, do not send the user-facing booking confirmation email. Used by system-initiated auto-save rebooks, which send their own combined rebooked email instead of the standard confirmation.
     * @type {boolean}
     * @memberof VehicleBookingRequest
     */
    suppressUserEmail?: boolean;
    /**
     * 
     * @type {RateUpdateType}
     * @memberof VehicleBookingRequest
     */
    rateUpdateType?: RateUpdateType;
    /**
     * 
     * @type {BookingUserEnvironment}
     * @memberof VehicleBookingRequest
     */
    userEnvironment?: BookingUserEnvironment;
}



/**
 * Check if a given object implements the VehicleBookingRequest interface.
 */
export function instanceOfVehicleBookingRequest(value: object): value is VehicleBookingRequest {
    if (!('searchId' in value) || value['searchId'] === undefined) return false;
    if (!('rateCode' in value) || value['rateCode'] === undefined) return false;
    if (!('vendorCode' in value) || value['vendorCode'] === undefined) return false;
    if (!('acrissCode' in value) || value['acrissCode'] === undefined) return false;
    if (!('givenName' in value) || value['givenName'] === undefined) return false;
    if (!('familyName' in value) || value['familyName'] === undefined) return false;
    if (!('emailAddress' in value) || value['emailAddress'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('paymentId' in value) || value['paymentId'] === undefined) return false;
    return true;
}

export function VehicleBookingRequestFromJSON(json: any): VehicleBookingRequest {
    return VehicleBookingRequestFromJSONTyped(json, false);
}

export function VehicleBookingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleBookingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'searchId': json['search_id'],
        'rateCode': json['rate_code'],
        'selectedRateType': json['selected_rate_type'] == null ? undefined : json['selected_rate_type'],
        'vendorCode': json['vendor_code'],
        'acrissCode': json['acriss_code'],
        'pickupLocation': json['pickup_location'] == null ? undefined : json['pickup_location'],
        'vendorLocationId': json['vendor_location_id'] == null ? undefined : json['vendor_location_id'],
        'deskKind': json['desk_kind'] == null ? undefined : json['desk_kind'],
        'extras': json['extras'] == null ? undefined : json['extras'],
        'givenName': json['given_name'],
        'familyName': json['family_name'],
        'emailAddress': json['email_address'],
        'phoneNumber': json['phone_number'],
        'paymentId': json['payment_id'],
        'promotionalCode': json['promotional_code'] == null ? undefined : json['promotional_code'],
        'loyaltyAccountId': json['loyalty_account_id'] == null ? undefined : json['loyalty_account_id'],
        'test': json['test'] == null ? undefined : json['test'],
        'suppressUserEmail': json['suppress_user_email'] == null ? undefined : json['suppress_user_email'],
        'rateUpdateType': json['rate_update_type'] == null ? undefined : RateUpdateTypeFromJSON(json['rate_update_type']),
        'userEnvironment': json['user_environment'] == null ? undefined : BookingUserEnvironmentFromJSON(json['user_environment']),
    };
}

export function VehicleBookingRequestToJSON(json: any): VehicleBookingRequest {
    return VehicleBookingRequestToJSONTyped(json, false);
}

export function VehicleBookingRequestToJSONTyped(value?: VehicleBookingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_id': value['searchId'],
        'rate_code': value['rateCode'],
        'selected_rate_type': value['selectedRateType'],
        'vendor_code': value['vendorCode'],
        'acriss_code': value['acrissCode'],
        'pickup_location': value['pickupLocation'],
        'vendor_location_id': value['vendorLocationId'],
        'desk_kind': value['deskKind'],
        'extras': value['extras'],
        'given_name': value['givenName'],
        'family_name': value['familyName'],
        'email_address': value['emailAddress'],
        'phone_number': value['phoneNumber'],
        'payment_id': value['paymentId'],
        'promotional_code': value['promotionalCode'],
        'loyalty_account_id': value['loyaltyAccountId'],
        'test': value['test'],
        'suppress_user_email': value['suppressUserEmail'],
        'rate_update_type': RateUpdateTypeToJSON(value['rateUpdateType']),
        'user_environment': BookingUserEnvironmentToJSON(value['userEnvironment']),
    };
}

